export class Person {
    //public id:number;
    public tipoDocumento :string= "";
    public numeroDocumento: string ="";
    public nombres:string ="";
    public apellidos:string="";
    public correo:string="";
}
